import React from "react";
import ServerDataGrid from "../../Common/DataGrid/ServerDataGrid/ServerDataGrid";
import urlHelper from "../../../infrastructure/helpers/common/urlHelper";
import appRoutes from "../../../infrastructure/constants/appRoutes";
import history from '../../../infrastructure/helpers/react/history';
import { getColumns } from "./MasterConfiguration.Grid";
import reportRegimeHelper from "../../../infrastructure/helpers/report/reportRegime/reportRegimeHelper";

const uniqueName = 'master-configuration-grid';

class MasterConfigurationHomePage extends React.Component<any> {

    constructor(props: any) {
        super(props);

        this.onEditClick = this.onEditClick.bind(this);
    }

    onEditClick(regime: string) {

        let route = urlHelper.buildUrl(appRoutes.masterConfiguration.edit, { regime: reportRegimeHelper.getRegimeDisplayName(regime) });

        history.push(route);
    }

    render(): JSX.Element {

        return (
            <>
                <h3>Master Configuration</h3>
                <ServerDataGrid
                    columns={getColumns(this.onEditClick)}
                    uniqueName={uniqueName}
                    dataSourceRoute="master-configuration/page"
                    pageSize={10}
                    getKey={x => x} />
            </>
        )
    }
}

export default MasterConfigurationHomePage;